var map = {
	"./de/btn-view.png": "HTiV",
	"./en/btn-view.png": "f7iL",
	"./es/btn-view.png": "5T8U",
	"./fr/btn-view.png": "YH/P",
	"./ja/btn-view.png": "N5A2",
	"./ko/btn-view.png": "5Kpn",
	"./pt/btn-view.png": "LgQu",
	"./ru/btn-view.png": "J4fp",
	"./tc/btn-view.png": "0wlK",
	"./th/btn-view.png": "sq5i"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "reA5";